import api from "./api";

const parametrizationService = {};
const endpoint = "/parametrizations";

parametrizationService.findByParameterName = function (parameterName) {
  return api
    .get(`${endpoint}/by-name/${parameterName}`, { silent: true })
    .then(({ data }) => data);
};

parametrizationService.isBooleanEnabled = async function (parameterName) {
  try {
    const parametrization = await this.findByParameterName(parameterName);
    return (
      parametrization?.parameterValue === true &&
      parametrization?.parameterType === "boolean"
    );
  } catch (error) {
    return false;
  }
};

export default parametrizationService;
